module.exports = "<td class=\"logDate\"><span class=\"statusicon\" title=\"<%= i18n._('log.table.line.state.'+ model.get('level')) %>\"><%= i18n._('log.table.line.state.'+ model.get('level')) %></span> <%= model.get('dated') %></td>\r\n<td class=\"logState textleft\"><%= model.get('username') %></td>\r\n<td class=\"logDesc\"><%= i18n._(model.get('message'),model.getAParameter(0),model.getAParameter(1),model.getAParameter(2),model.getAParameter(3)) %></td>"


//////////////////
// WEBPACK FOOTER
// ./src/components/protocol/templates/row_view.template
// module id = 535
// module chunks = 51